import 'css-chunksrc/client/common/constraintsPopup/list/styles.scss';export default {
  "list": "_list_1m0xy_1",
  "title": "_title_1m0xy_9",
  "item": "_item_1m0xy_15",
  "element": "_element_1m0xy_25",
  "icon": "_icon_1m0xy_33",
  "name": "_name_1m0xy_36",
  "button": "_button_1m0xy_51"
};